import {Axios} from '../axios/axios.js'
//任务列表
export const getOperationList = (e) => {
  return Axios({
    url:"operation/index",
    method:'put',
    data:e
  })
}
// /operation/task
export const getTaskLogList = (e) => {
  return Axios({
    url:"operation/task",
    method:'put',
    data:e
  })
}
export const getDriverLogList = (e) => {
  return Axios({
    url:"operation/driver",
    method:'put',
    data:e
  })
}
